import { cn } from '@/lib/utils'
import { MARK_LAYER_RADIUS, MARK_LAYER_SIZE, MARK_LAYERS, MARK_STROKE_WIDTH, MARK_TRIANGLE, MARK_VIEWBOX } from './markGeometry'

type PlayLogoProps = { className?: string; markOnly?: boolean; inverse?: boolean }

/** Supplied StreamBridge lockup; link semantics belong to the caller. */
export function PlayLogo({ className, markOnly = false, inverse = false }: PlayLogoProps) {
  if (!markOnly) {
    return (
      <span className={cn('play-logo', className)} role="img" aria-label="StreamBridge">
        <img className="play-logo__lockup" src="/brand/play/streambridge-logo.svg" width="475.4" height="145" alt="" aria-hidden="true" />
      </span>
    )
  }

  return (
    <span className={cn('play-logo play-logo--mark', inverse && 'play-logo--inverse', className)} role="img" aria-label="StreamBridge">
      <svg className="play-logo__mark" viewBox={MARK_VIEWBOX} fill="none" aria-hidden="true">
        <g stroke="var(--play-ink)" strokeWidth={MARK_STROKE_WIDTH}>
          {MARK_LAYERS.map(({ x, y, fill }) => (
            <rect key={fill} x={x} y={y} width={MARK_LAYER_SIZE} height={MARK_LAYER_SIZE} rx={MARK_LAYER_RADIUS} fill={fill} />
          ))}
        </g>
        <path d={MARK_TRIANGLE} fill="var(--play-ink)" />
      </svg>
    </span>
  )
}
